export default{
    pdf: 'application/pdf',
    txt: 'text/plain',
    zip: 'application/zip'
}
